 import React, {Component} from 'react';
import {connect} from 'react-redux';
import PremiumSettings from '../../components/PremiumSettings/PremiumSettings';
import { push } from 'connected-react-router'
import {
	changeNewPremiumStoreSettings,
	changepsType, changeSolicitorGroup, changeWorksource, deletePremiumSetting, displayOnlyLive, getAllPremiumSettings,
	getAllPremiumSettingsWithCombination,
	getPRemiumSettingsForSolicitorGroupAndWorkSource, getPremiumSettingWithCombination, goToPage, openModal, pageShift,
	requestPremiumSettingsDamages,changePremiumSettingWithCombination, updateDisplayed
} from "../../actions/premiumSettings";
import {requestGetSolicitorGroups, requestGetWorkSources} from "../../actions/solicitorGroup";
import _ from 'lodash';
import {getCaseTypes} from "../../actions/caseTypes";
import {getSolicitorGroupCaseTypes} from "../../actions/groups";
import {requestGetSolicitorGroupWorkSources} from "../../actions/newApplication";
import { CANADA_COUNTRY, COUNTRY, PERCENTAGE_PREMIUMS_AVAILABLE } from '../../helpers/variables';
import { PS_TYPE_CUSTOM, PS_TYPE_DEFAULT, PS_TYPE_PERCENTAGE, PS_TYPE_PERCENTAGE_CASE_TYPES, PS_TYPE_STAGED } from '../../helpers/constants';
import { stringToNumber } from '../../helpers/functions';
import { changeSubSettings } from '../../reducers/stagedPremiumsWizard';
import { changeStagedPremiumData, getAllStagedPremium, getCurrentStagedPremium } from '../../reducers/stagedPremiums';


class PremiumSettingsHOC extends Component {
	constructor(props){
		super(props);
		this.state = {
			isCopyModalOpen: false,
			isCopyStagedModalOpen:false
		}
	}

	componentWillMount = () => {
		this.props.getCaseTypes();
		this.props.getSolicitorGroups();
		this.props.getWorkSources();
		this.props.requestPremiumSettingsDamages();
		if(this.props.premiumSettings && this.props.premiumSettings.showTable && !this.props.premiumSettings.fetchingPremiumWithCombination && !_.isEmpty(this.props.premiumSettings.fetchedPremiumWithCombination))
		{
			this.props.changePremiumSettingWithCombination(this.props.premiumSettings.fetchedPremiumWithCombination);
		}
	};

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.premiumSettings.showAllPremiumSettingsForCombination && !this.props.premiumSettings.showAllPremiumSettingsForCombination &&
			 this.props.premiumSettings.caseTypeId !== '' && this.props.premiumSettings.psType !== PS_TYPE_STAGED) {
            let payload = {
                caseTypeId: this.props.premiumSettings.selectedCaseType,
                subCaseTypeId: this.props.premiumSettings.selectedSubCaseType === '' || this.props.premiumSettings.selectedSubCaseType === '0' ? -1 : this.props.premiumSettings.selectedSubCaseType,
                solicitorGroupId: this.props.premiumSettings.selectedSolicitorGroup === '' ? -1 : this.props.premiumSettings.selectedSolicitorGroup,
                workSourceId: this.props.premiumSettings.selectedWorksource === '' ? -1 : this.props.premiumSettings.selectedWorksource,
				isTypePercentage: this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE
            };
            this.props.getAllPremiumSettingsWithCombination(payload);
        }
        if (!nextProps.premiumSettings.showAllPremiumSettingsForCombination && this.props.premiumSettings.showAllPremiumSettingsForCombination && this.props.premiumSettings.caseTypeId !== ''
		&& this.props.premiumSettings.psType !== PS_TYPE_STAGED) {
            this.props.getPremiumSettingWithCombination(
                nextProps.premiumSettings.selectedCaseType,
                nextProps.premiumSettings.selectedSubCaseType === '' || nextProps.premiumSettings.selectedSubCaseType === '0' ? -1 : nextProps.premiumSettings.selectedSubCaseType,
                nextProps.premiumSettings.selectedSolicitorGroup === '' ? -1 : nextProps.premiumSettings.selectedSolicitorGroup,
                nextProps.premiumSettings.selectedWorksource === '' ? -1 : nextProps.premiumSettings.selectedWorksource,
				nextProps.premiumSettings.psType === PS_TYPE_PERCENTAGE
            )
        }

		//CHECK FOR STAGED
		if (nextProps.stagedPremiums.getAllStagedPremiumsForCombination && !this.props.stagedPremiums.getAllStagedPremiumsForCombination &&
			 this.props.premiumSettings.caseTypeId !== '' && this.props.premiumSettings.psType == PS_TYPE_STAGED) {
            let payload = {
                caseTypeId: this.props.premiumSettings.selectedCaseType,
                subCaseTypeId: this.props.premiumSettings.selectedSubCaseType === '' || this.props.premiumSettings.selectedSubCaseType === '0' ? -1 : this.props.premiumSettings.selectedSubCaseType,
                solicitorGroupId: this.props.premiumSettings.selectedSolicitorGroup === '' ? -1 : this.props.premiumSettings.selectedSolicitorGroup,
                workSourceId: this.props.premiumSettings.selectedWorksource === '' ? -1 : this.props.premiumSettings.selectedWorksource,
            };
            //call all staged
			this.props.requestAllStagedPremiumSettings(payload);
        }
        if (!nextProps.stagedPremiums.getAllStagedPremiumsForCombination && this.props.stagedPremiums.getAllStagedPremiumsForCombination && this.props.premiumSettings.caseTypeId !== ''
		&& this.props.premiumSettings.psType == PS_TYPE_STAGED) {
            //call single/current staged
			let payload = {
                caseTypeId: nextProps.premiumSettings.selectedCaseType,
                subCaseTypeId: nextProps.premiumSettings.selectedSubCaseType === '' || nextProps.premiumSettings.selectedSubCaseType === '0' ? -1 : nextProps.premiumSettings.selectedSubCaseType,
                solicitorGroupId: nextProps.premiumSettings.selectedSolicitorGroup === '' ? -1 : nextProps.premiumSettings.selectedSolicitorGroup,
                workSourceId: nextProps.premiumSettings.selectedWorksource === '' ? -1 : nextProps.premiumSettings.selectedWorksource
            };

            this.props.requestStagedPremiumSetting(payload)
        }
    };

	closeCopyModal = () => this.setState({...this.state, isCopyModalOpen: false});

	openCopyModal = () => this.setState({...this.state, isCopyModalOpen: true});
	toggleStagedCopyModal = () => this.setState({...this.state, isCopyStagedModalOpen: !this.state.isCopyStagedModalOpen});

	handleSolGroupsChange = (name, value) => {
		this.props.getSolicitorGroupCaseTypes(value?value:-1);
		this.props.requestGetSolicitorGroupWorkSources(value?value:-1)
        this.props.changeNewPremiumStoreSettings(name, value);
        this.props.changeNewPremiumStoreSettings('selectedWorksource', '');
        this.props.changeNewPremiumStoreSettings('selectedWorksourceName', '');
        this.props.changeNewPremiumStoreSettings('selectedSubCaseType', '');
        this.props.changeNewPremiumStoreSettings('selectedCaseType', '');
	};

	viewEditForm = (changedField, changedValue) => {
		let selectedWorkSource = this.props.premiumSettings.selectedWorksource === '' ? -1 : this.props.premiumSettings.selectedWorksource;
		let selectedCaseType = this.props.premiumSettings.selectedCaseType;
		let selectedSubCaseType = this.props.premiumSettings.selectedSubCaseType === '' ||this.props.premiumSettings.selectedSubCaseType === '0'  ? -1 : this.props.premiumSettings.selectedSubCaseType;
		if (changedField === 'selectedWorksource') {
			if(this.props.premiumSettings.selectedCaseType === ''){
				return null
			}
			if (changedValue) {
				selectedWorkSource = changedValue
			}
			else {
				selectedWorkSource = -1;
			}
		}
		else if (changedField === 'selectedCaseType') {
			if (changedValue) {
				selectedCaseType = changedValue;
				selectedSubCaseType = -1;
			}
			else {
				return null;
			}
		}
		else if (changedField === 'selectedSubCaseType') {
			if(this.props.premiumSettings.selectedCaseType === '') {
				return null
			}
			if (changedValue) {
				if (changedValue === '0') {
					selectedSubCaseType = -1;
				}
				else {
					selectedSubCaseType = changedValue
				}

			}
			else {
				selectedSubCaseType = -1;
			}
		}
		
		this.props.premiumSettings.psType !== PS_TYPE_STAGED && this.props.getPremiumSettingWithCombination(
			selectedCaseType,
			selectedSubCaseType,
			this.props.premiumSettings.selectedSolicitorGroup === '' ? -1 : this.props.premiumSettings.selectedSolicitorGroup,
			selectedWorkSource,
			this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE
		)

		let payload = {
			caseTypeId: selectedCaseType,
			subCaseTypeId: selectedSubCaseType,
			solicitorGroupId: this.props.premiumSettings.selectedSolicitorGroup === '' ? -1 : this.props.premiumSettings.selectedSolicitorGroup,
			workSourceId: selectedWorkSource
		};
		this.props.premiumSettings.psType == PS_TYPE_STAGED && this.props.requestStagedPremiumSetting(payload);

	};

	handleDeletePremiumSetting = (setting) => {
		//ask for confirmation
		this.props.deletePremiumSetting({id: setting});
	};
	
	//function that filters the case types based on the selected solicitor group
    getCaseTypesBySolicitorGroup = () => {
        if (this.props.premiumSettings.psType === PS_TYPE_DEFAULT) {
            return [{key: '', value: 'None'}, ...this.props.caseTypes.map(caseType => {
                return {
                    key: caseType.id,
                    value: caseType.name
                }
            })]
        }
		else if(this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE && PERCENTAGE_PREMIUMS_AVAILABLE){
            return [{key: '', value: 'None'}, ...this.props.caseTypes.filter(ct => PS_TYPE_PERCENTAGE_CASE_TYPES.includes(ct.machineName)).map(caseType => {
                return {
                    key: caseType.id,
                    value: caseType.name
                }
            })]
		}
        return [{key: '', value: 'None' }, ...this.props.premiumSettings.groupCaseTypes.map(caseType => {
            return {
                key: caseType.id,
                value: caseType.name
            }
        })];
    };

	//function that gets sub cases of selected case type
	getSubCaseTypes = () => {
        if(this.props.premiumSettings.psType === PS_TYPE_DEFAULT){
            return [{key: '', value: ''}, ..._.filter(this.props.subCaseTypes, item => {
                return  item.caseTypeId.toString() === this.props.premiumSettings.selectedCaseType
            }).map(item => {return {key: item.id, value: item.name}})]
        }
        else if(this.props.premiumSettings.psType === PS_TYPE_CUSTOM || this.props.premiumSettings.psType === PS_TYPE_STAGED
			|| (this.props.premiumSettings.psType === PS_TYPE_PERCENTAGE && PERCENTAGE_PREMIUMS_AVAILABLE)
		) {
            let o = [];
            _.forEach(this.props.premiumSettings.groupCaseTypes, ctype => {
            	if(ctype.id.toString() === this.props.premiumSettings.selectedCaseType){
            		_.forEach(ctype.subCaseTypes, sctype => {
            			o.push(sctype)
					})
				}
			});
			return [{key: '', value: ''},...o.map(item => {return {key: item.id, value: item.name}})];
        }
        return [];
	};

	//handler for checkbox of all premium settings
	handleAllPremiumChange = (name, value) => {
		if(value)
			this.props.changeNewPremiumStoreSettings(name, value);
		else {
			this.props.changeNewPremiumStoreSettings('allPremiumSettingsForCombination', []);
			this.props.changeNewPremiumStoreSettings(name, value);
		}
	};
	handleAllStagedPremiumChange = (name, value) => {
		if(value)
			this.props.changeStagedPremiumStoreData(name, value);
		else {
			this.props.changeStagedPremiumStoreData('allStagedPremiumSetting', []);
			this.props.changeStagedPremiumStoreData(name, value);
		}
	};


	createNewHandle = () => {
		if (this.props.premiumSettings.fetchingPremiumWithCombination)
			return false;
		if (this.props.premiumSettings.psType === PS_TYPE_DEFAULT) {
			this.props.changeNewPremiumStoreSettings('selectedSolicitorGroup', '');
			this.props.changeNewPremiumStoreSettings('selectedWorksource', '');
		}
		if (this.props.premiumSettings.psType === PS_TYPE_STAGED && COUNTRY == CANADA_COUNTRY) {
			this.props.push('premium-settings/new-staged-premium-settings')
			return false
		}
		this.props.push('premium-settings/new-premium-settings');
	}
	editHandle = () => {
		if (this.props.premiumSettings.fetchingPremiumWithCombination)
			return false;
		if (this.props.premiumSettings.psType === PS_TYPE_DEFAULT) {
			this.props.changeNewPremiumStoreSettings('selectedSolicitorGroup', '');
			this.props.changeNewPremiumStoreSettings('selectedWorksource', '');
		}
		if (this.props.premiumSettings.psType === PS_TYPE_STAGED) {
			this.props.push('premium-settings/edit-staged-premium-settings/' + this.props.stagedPremiums.stagedPremiumSetting?.id)
			return false
		}
		if (this.props.premiumSettings.editingPremiumSettingId)
			this.props.push('premium-settings/edit-premium-settings/' + this.props.premiumSettings.editingPremiumSettingId)
	}
	amountColumnsDisplayDataPerStage = (stage) => {
		const commissionsAgentsData = this.props.stagedPremiums.agentCommissionsList.map(a =>
		  ({ title: a.name, value: stringToNumber(a.commissionPercentage) * 0.01 * stringToNumber(stage.premiumAmount), isPlain: true, onChange: () => null }))
		return [
		  {
			title: 'Premium', value: stage.premiumAmount, isPlain: false, onChange: (e) =>
			changeSubSettings(this.props.stagedPremiums.stagedPremiumSetting
			  .findIndex(c => c.stageMachineName == stage.stageMachineName), 'premiumAmount', e.target.value)
		  },
		  {
			title: 'Limit of Indemnity', value: stage.limitOfIndemnity, isPlain: false, onChange: (e) =>
			changeSubSettings(this.props.stagedPremiums.stagedPremiumSetting
			  .findIndex(c => c.stageMachineName == stage.stageMachineName), 'limitOfIndemnity', e.target.value)
		  },
		  { title: 'Underwriter rate', value: stringToNumber(this.props.stagedPremiums.underwriterRatePercentage) * 0.01 * stringToNumber(stage.premiumAmount), isPlain: true, onChange: () => null },
		  ...commissionsAgentsData
		]
	  }
	render() {
		return (
			<PremiumSettings
				amountColumnsDisplayDataPerStage={this.amountColumnsDisplayDataPerStage}
				editHandle={this.editHandle}
				createNewHandle={this.createNewHandle}
				getSolicitorGroupCaseTypes={this.props.getSolicitorGroupCaseTypes}
				requestGetSolicitorGroupWorkSources={this.props.requestGetSolicitorGroupWorkSources}
                fetchingSolicitorGroupWorkSources={this.props.fetchingSolicitorGroupWorkSources}
                fetchingSolicitorGroupCaseTypes={this.props.fetchingSolicitorGroupCaseTypes}
				handleAllPremiumChange={this.handleAllPremiumChange} //handler for checkbox of all premium settings
				groupCaseAndSubTypes={this.props.premiumSettings.groupCaseTypes} // case types options
				caseTypes={this.getCaseTypesBySolicitorGroup()} // case types options
				caseTypesRecords={this.props.caseTypes} // case types fetched from the api
				subCaseTypes={this.getSubCaseTypes()} //sub cases options
				subCaseTypesRecords={this.props.subCaseTypes} //fetched subs case types form API
				fetchingCaseTypes={this.props.fetchingCaseTypes} //case types fetching indicator
				handleDeletePremiumSetting={this.handleDeletePremiumSetting}
				viewEditForm={this.viewEditForm}
				getPRemiumSettingsForSolicitorGroupAndWorkSource={this.props.getPRemiumSettingsForSolicitorGroupAndWorkSource}
				handleSolGroupsChange={this.handleSolGroupsChange}
				changeNewPremiumStoreSettings={this.props.changeNewPremiumStoreSettings}
				premiumSettings={this.props.premiumSettings}
				updateDisplayed={this.props.updateDisplayed}
				displayOnlyLive={this.props.displayOnlyLive}
				changepsType={(tab) => this.props.changepsType(tab)}
				openModal={this.props.openModal}
				changeSolicitorGroup={this.props.changeSolicitorGroup}
				changeWorksource={this.props.changeWorksource}
				push={this.props.push}
				DisplayDialogBox={this.props.displayDialogBox}
				HandleInputChange={this.props.userLoginProperties}
				pageShift={this.props.pageShift}
				allPossibleDamages = {this.props.damages}
				closeCopyModal={this.closeCopyModal}
				openCopyModal={this.openCopyModal}
				isCopyModalOpen={this.state.isCopyModalOpen}
				stagedPremiums={this.props.stagedPremiums}
				handleAllStagedPremiumChange={this.handleAllStagedPremiumChange}
				isCopyStagedModalOpen={this.state.isCopyStagedModalOpen}
				toggleStagedCopyModal={this.toggleStagedCopyModal}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		stagedPremiums: state.stagedPremiums,
		premiumSettings: state.premiumSettings,
		caseTypes: state.caseTypes.cases,
		subCaseTypes: state.caseTypes.subCases,
		fetchingCaseTypes: state.caseTypes.fetching,
		damages: state.damages,
        fetchingSolicitorGroupCaseTypes: state.groups.fetchingSolicitorGroupCaseTypes,
        fetchingSolicitorGroupWorkSources: state.groups.fetchingSolicitorGroupWorkSources
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAllPremiumSettings: () => {
			dispatch(getAllPremiumSettings())
		},
		changeSubSettings: (target,key,value) => {
			dispatch(changeSubSettings({target,key,value}))
		},
		updateDisplayed: (payload) => {
			dispatch(updateDisplayed(payload))
		},
		displayOnlyLive: () => {
			dispatch(displayOnlyLive())
		},
		getSolicitorGroups: () => {
			dispatch(requestGetSolicitorGroups())
		},
		getWorkSources: () => {
			dispatch(requestGetWorkSources())
		},
		changepsType: (payload) => {
			dispatch(changepsType(payload))
		},
		openModal: (payload) => {
			dispatch(openModal(payload))
		},
		changeSolicitorGroup: (payload) => {
			dispatch(changeSolicitorGroup(payload))
		},
		changeWorksource: (payload) => {
			dispatch(changeWorksource(payload))
		},
		push: (url) => {
			dispatch(push(url))
		},
		changeNewPremiumStoreSettings: (key, value) => {
			dispatch(changeNewPremiumStoreSettings(key, value))
		},
		changeStagedPremiumStoreData: (key, value) => {
			dispatch(changeStagedPremiumData({key, value}))
		},
		getPRemiumSettingsForSolicitorGroupAndWorkSource: (solId, worksourceId) => {
			dispatch(getPRemiumSettingsForSolicitorGroupAndWorkSource(solId, worksourceId))
		},
		deletePremiumSetting: (payload) => {
			dispatch(deletePremiumSetting(payload))
		},
		pageShift: (direction, totalPaginationBoxes) => {
			dispatch(pageShift(direction, totalPaginationBoxes))
		},
		goToPage: (payload) => {
			dispatch(goToPage(payload))
		},
		getCaseTypes: () => {
			dispatch(getCaseTypes())
		},
		getPremiumSettingWithCombination: (caseTypeId, subCaseTypeId, solicitorGroupId, workSourceId, premiumSettingTypePercentage) => {
			dispatch(getPremiumSettingWithCombination(caseTypeId, subCaseTypeId, solicitorGroupId, workSourceId, premiumSettingTypePercentage))
		},
		changePremiumSettingWithCombination: (premSettings) => {
			dispatch(changePremiumSettingWithCombination(premSettings))
		},
		requestPremiumSettingsDamages: () => {
			dispatch(requestPremiumSettingsDamages())
		},
		getAllPremiumSettingsWithCombination: (payload) => {
			dispatch(getAllPremiumSettingsWithCombination(payload))
		},
        getSolicitorGroupCaseTypes: (groupId) => {
			dispatch(getSolicitorGroupCaseTypes(groupId))
		},
        requestGetSolicitorGroupWorkSources: (groupId) => {
			dispatch(requestGetSolicitorGroupWorkSources(groupId))
		},
        requestAllStagedPremiumSettings: (payload) => {
			dispatch(getAllStagedPremium(payload))
		},
		requestStagedPremiumSetting: (payload) => {
			dispatch(getCurrentStagedPremium(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumSettingsHOC);
